module.exports = __webpack_public_path__ + "static/polyback-3c40f355794e2cbb5d5aef64d3bf911c.svg";